import {
  TPillarsFocusesUI,
  TPillarsOfStrengthResponseUI,
  TPillarsResponseUI,
} from 'data/types/pillars.types';
import { EPillarsUrls } from 'data/urls/pillars.url';
import { authSplitApi } from 'redux/helpers/slice.helpers';

const baseUrl = `${EPillarsUrls.PILLARS}`;

export const pillarsApi = authSplitApi('pillars', [
  'pillars',
  'pillars-focuses',
  'pillars-of-strength',
]).injectEndpoints({
  endpoints: build => ({
    getPillarsList: build.query<TPillarsResponseUI, void>({
      query() {
        return {
          url: `${baseUrl}`,
          method: 'GET',
        };
      },
      providesTags: ['pillars'],
    }),
    getPillarsFocusesList: build.query<
      TPillarsFocusesUI[],
      { pillarId: string }
    >({
      query({ pillarId }) {
        return {
          url: `${baseUrl}/${EPillarsUrls.FOCUSES}`,
          method: 'GET',
          params: { pillarId },
        };
      },
      providesTags: ['pillars-focuses'],
    }),
    getPillarsOfStrength: build.query<
      TPillarsOfStrengthResponseUI,
      { elcId: string }
    >({
      query({ elcId }) {
        return {
          url: `${baseUrl}/${EPillarsUrls.PILLARS_OF_STRENGTH}`,
          method: 'GET',
          params: { elcId },
        };
      },
      providesTags: ['pillars-of-strength'],
    }),
  }),
});
export const {
  useGetPillarsListQuery,
  useGetPillarsFocusesListQuery,
  useGetPillarsOfStrengthQuery,
} = pillarsApi;
